export const hasPermission = (user, permCode) => {
  if (!user?.permissions?.length || !permCode) {
    return false;
  }
  return user.permissions.some((p) => p.perm_code === permCode);
};

export const hasAnyPermission = (user, permCodes = []) => {
  return permCodes.some((code) => hasPermission(user, code));
};

export const hasAllPermissions = (user, permCodes = []) => {
  return permCodes.every((code) => hasPermission(user, code));
};
